import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { projectTeamManagementTranslationRef } from '@internal/plugin-project-team-management/src/components/translation';

export const projectTeamManagementTranslations = createTranslationResource({
  ref: projectTeamManagementTranslationRef,
  translations: {
    en: () => import('./project-team-management-en'),
    es: () => import('./project-team-management-es'),
  },
});